import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { TextInput, Button, CheckBox, Container, Row } from '../../../components';
import { LanguageContext } from '../../../context/Languages/LanguageProvider';

import { Col } from 'react-flexbox-grid';

const Payment = () => {
  const { i18n } = useContext(LanguageContext);
  const { errors } = useForm();

  return (
    <Container>
      <h4>{i18n.letUsKnowWhoYouAre}</h4>
      <Row>
        <Col lg={12}>
          <label>{i18n.yourName}</label>
          <TextInput placeholder={i18n.yourName} name="fullName" type="text" error={errors.email} />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <label>{i18n.emailAddress}</label>
          <TextInput placeholder={i18n.emailAddress} name="email" type="email" error={errors.email} />
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <label>{i18n.phoneNumber}</label>
          <TextInput placeholder={i18n.phoneNumber} name="phone" type="text" error={errors.email} />
        </Col>
        <Col lg={6}>
          <label>{i18n.country}</label>
          <select name="country">
            <option>Saudi Arabia</option>
            <option>Dubai</option>
            <option>Yemen</option>
          </select>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <CheckBox label={i18n.pleaseTickIfYouMaking} />
        </Col>
      </Row>
      <Button>{i18n.nextPage}</Button>
    </Container>
  );
};

export default Payment;
